<!-- // todo 取自transcc,修改限制不显示交易,默认放大,只包含行情组件 -->
<template>
  <div>
    <div :id="isChangeFooter?'transCC-change':'transCC'">
      <!-- <div id="transCC-change"> -->
      <div class="transCC-outbox">
        <!-- <div class="transCC-box1 transCC-box">
          <CoinInfo></CoinInfo>
        </div> -->
        <div class="transCC-box2 transCC-box">
          <NewTransccTopLine />
        </div>
        <div class="transCC-box3 transCC-box">
          <!-- k线 -->
          <QuotationLineCC v-if="!isChangeFooter" ref="QuotationLineCC" :trans-c-c-default-t-v-style="defaultTVStyle" @setDefaultTVStyle="setDefaultTVStyle"></QuotationLineCC>
          <QuotationLineCCLong v-else ref="QuotationLineCC" :trans-c-c-default-t-v-style="defaultTVStyle" @setDefaultTVStyle="setDefaultTVStyle"></QuotationLineCCLong>
        </div>
        <!-- <div class="transCC-new-box transCC-box">

        </div> -->
        <div class="transCC-box4 transCC-box">
          <!-- 委托列表 -->
          <TopViewCC></TopViewCC>
        </div>
        <div class="transCC-box5 transCC-box">
          <!-- 盘口明细 -->
          <NewGoodsMsg style="margin-top: 6px;padding:4px 0" />
        </div>
        <div class="transCC-box transCC-box8">
          <!-- <TransViewCC current-height="394px" /> -->
          <TransViewCC current-height="100%" />
        </div>
        <div class="transCC-box" :class="currentName=='pk'?'transCC-box6':'tab-transCC-box6'">
          <!-- 盘口 公告 简报 明细 -->
          <Tabs @changTab="changTabSty" />
        </div>
        <!-- <div class="changeLine" @click="changeClick">切换</div> -->
        <div class="transCC-box7 transCC-box">
          <!-- <NewFooter /> -->
        </div>
        <div class="transCC-box9 transCC-box">
          <div class="changeBtn">
            <!-- <img v-if="!isChangeFooter" src="../../assets/images/newfooter-2.png" @click="changeClick">
            <img v-else src="../../assets/images/newfooter-1.png" @click="changeClick"> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
// import NoticeCC from './notice/NoticeCC'

import TopViewCC from './topview/TopViewCC'
import TransViewCC from './transview/TransViewCC'

import QuotationLineCC from './quotationline/QuotationLineCC' // hqchart版本
import QuotationLineCCLong from './quotationline/QuotationLineCC_Long' // hqchart版本
// import QuotationLineCC from './quotationline/QuotationLineCC1' // tradingview版本
// import QuotationLineCCLong from './quotationline/QuotationLineCC_Long1' // tradingview版本
// 新增 UI
import NewTransccTopLine from './new/NewTransccTopLine.vue'
import NewGoodsMsg from './new/NewGoodsMsg.vue'
import Tabs from './notice/Tabs.vue'
// import NewFooter from './new/NewFooter.vue'
export default {
  name: 'TransCC',
  components: {
    // NoticeCC,
    TopViewCC,
    TransViewCC,
    QuotationLineCC,
    QuotationLineCCLong,
    NewTransccTopLine,
    NewGoodsMsg,
    Tabs
    // NewFooter
  },
  data() {
    return {
      systemTime: new Date(),
      SYSTIME: null,
      timerClick: null,
      currentName: 'pk',
      isChangeFooter: true,
      defaultTVStyle: null,
      changeTime: 0,
      maxChangeTime: 4 // 必须是偶数!!
    }
  },
  computed: {
    ...mapGetters(['sessionInfoGetter', 'marketDetails']),
    isLogin() {
      if (this.sessionInfoGetter && this.sessionInfoGetter['sessionStr'] && this.sessionInfoGetter['userId']) {
        return true
      }
      return false
    }
  },
  watch: {
    // 系统时间
    systemTime(val, oldVal) {
      this.$store.commit('setSystemTime', val) // 更新系统时间 setSystemTime
    }
  },
  created() {
    if (this.$route.query.ids == 1) {
      this.defaultTVStyle = JSON.parse(localStorage.getItem('__local_defaultTVStyle'))
    }
  },
  mounted() {
    // this.isChangeFooter = localStorage.getItem('__local_isChangeFooter') == 'true' ? true : false
    // this.getIdentificationStatus()
    this.param_queryServerTime() // 查询系统时间
    this.timerClick = setTimeout(() => {
      this.changeTimer()
    }, 1000)
  },
  beforeCreate() {
  },
  beforeDestroy() {
    if (this.SYSTIME) {
      clearTimeout(this.SYSTIME)
      this.SYSTIME = null
    }
    if (this.timerClick) {
      clearTimeout(this.timerClick)
      this.timerClick = null
    }
  },
  methods: {
    // 维护时间显示
    changeTimer() {
      if (!this.systemTime) {
        this.systemTime = new Date()
      } else {
        this.systemTime = Number(this.systemTime) + 1000
      }
      this.SYSTIME = setTimeout(() => {
        this.changeTimer()
      }, 1000)
    },
    // 查询系统时间
    param_queryServerTime() {
      http.postFront(protocol.param_queryServerTime).then(response => {
        const { code, value } = response.data
        if (code == '0') {
          this.systemTime = value
        }
      })
    },
    setDefaultTVStyle(defaultTVStyle) {
      this.defaultTVStyle = defaultTVStyle
    },
    // 拉伸功能
    changeClick() {
      this.isChangeFooter = !this.isChangeFooter
      this.changeTime++
      if (this.changeTime >= this.maxChangeTime) {
        // localStorage.setItem('__local_isChangeFooter', this.isChangeFooter)
        localStorage.setItem('__local_defaultTVStyle', JSON.stringify(this.defaultTVStyle))
        this.$router.go(0)
      }
    },
    getIdentificationStatus() {
      BaseApi.findBaseUserAuditByUserId().then((response) => {
        const { code, message, value } = response.data
        if (code === 0 || code === '0') {
          if (
            value !== null &&
            JSON.stringify(value) !== '{}' &&
            value !== '0'
          ) {
            if (value.auditStatus === 1) {
              // //  '未审核'/'已认证'
              if (value.auditType === 'P') {
                // 个人
                this.$store.commit('setOwnSideName', value.name)
              } else if (value.auditType === 'O') {
                // 企业
                this.$store.commit('setOwnSideName', value.legalPersonName)
              }
            } else {
              // '已驳回'
              this.$store.commit('setOwnSideName', 'XXX')
            }
          } else {
            this.$store.commit('setOwnSideName', 'XXX')
          }
        } else {
          this.$message(message)
        }
      })
    },
    changTabSty(name) {
      this.currentName = name
    }
  }
}
</script>
<style scoped lang='scss'>
.changeLine{
  // height: 20px;
  // background: blue;
}
#transCC {
  background-color: #242c4c;
  .transCC-outbox {
    // display: flex;
    position: relative;
    // width: 1920px;
    height: 926px;
    .transCC-box{
      display: inline-block;
    }
    .transCC-box1{
      position: absolute;
      top: 0;
      left: 0;
      width: 352px;
      height: 501px;
    }
    .transCC-box2{
      position: absolute;
      top: 3px;
      left: 0;
      width: 100%;
      height: 40px;
    }
    .transCC-box3{
      position: absolute;
      top: 49px;
      left: 0;
      width:  calc(100% - 498px);
      height: 568px; // + 147
    }
    .transCC-new-box{
      position: absolute;
      top: 49px;
      right: 0;
      width: 361px;
      height: 583px;
    }
    .transCC-box4{
      position: absolute;
      top: 49px;
      right: 198px;
      width:294px;
      // width: 361px;
      height: 210px;
    }
    .transCC-box5{
      position: absolute;
      top: 256px;
      right: 198px;
      width:294px;
      // width: 361px;
      height: 257px;
    }
    .transCC-box6{
      position: absolute;
      right: 0;
      top: 519px;
      width: 492px;
      height: 28px;
      z-index: 100;
    }
    .tab-transCC-box6{
      position: absolute;
      right: 0;
      top: 49px;
      width: 492px;
      height: 497px;
      z-index: 100;
    }
    .transCC-box8{
      position: absolute;
      right: 0;
      top: 49px;
      width: 208px;
      height: 490px;
      z-index: 100;
      // border-left:2px solid  linear-gradient(45deg, rgba(94, 101, 146, 0.4) 0%, #464C74 62%, rgba(48, 53, 89, 0.4) 100%);
    }
    .transCC-box8::after{
    content:'';
      position: absolute;
      left:0;
      top:0;
      height:470px;
      width:2px;
      background: linear-gradient(45deg, rgba(94, 101, 146, 0.4) 0%, #464C74 62%, rgba(48, 53, 89, 0.4) 100%);
    }
    .transCC-box7{
      position: absolute;
      top: 573px;
      left: 0;
      width: 100%;
      height: 353px;
    }
    .transCC-box9 {
      position: absolute;
      right:0;
      left: 0;
      top: 558px;
      height: 14px;
      z-index: 100;
      text-align: center;
      cursor: pointer;
    }

  }
}
// --- 备份 ！！！ k线图没调大之前的
// #transCC {
//   background-color: #242c4c;
//   .transCC-outbox {
//     // display: flex;
//     position: relative;
//     // width: 1920px;
//     height: 926px;
//     .transCC-box{
//       display: inline-block;
//     }
//     .transCC-box1{
//       position: absolute;
//       top: 0;
//       left: 0;
//       width: 352px;
//       height: 501px;
//     }
//     .transCC-box2{
//       position: absolute;
//       top: 3px;
//       left: 0;
//       width: 100%;
//       height: 40px;
//     }
//     .transCC-box3{
//       position: absolute;
//       top: 49px;
//       left: 0;
//       width:  calc(100% - 498px);
//       height: 568px; // + 147
//     }
//     .transCC-new-box{
//       position: absolute;
//       top: 49px;
//       right: 0;
//       width: 361px;
//       height: 583px;
//     }
//     .transCC-box4{
//       position: absolute;
//       top: 49px;
//       right: 213px;
//       width:279px;
//       // width: 361px;
//       height: 200px;
//     }
//     .transCC-box5{
//       position: absolute;
//       top: 246px;
//       right: 213px;
//       width:279px;
//       // width: 361px;
//       height: 236px;
//     }
//     .transCC-box6{
//       position: absolute;
//       right: 0;
//       top: 488px;
//       width: 492px;
//       height: 28px;
//       z-index: 100;
//     }
//     .tab-transCC-box6{
//       position: absolute;
//       right: 0;
//       top: 49px;
//       width: 492px;
//       height: 467px;
//       z-index: 100;
//     }
//     .transCC-box8{
//       position: absolute;
//       right: 0;
//       top: 49px;
//       width: 213px;
//       height: 460px;
//       z-index: 100;
//       // border-left:2px solid  linear-gradient(45deg, rgba(94, 101, 146, 0.4) 0%, #464C74 62%, rgba(48, 53, 89, 0.4) 100%);
//     }
//     .transCC-box8::after{
//     content:'';
//       position: absolute;
//       left:0;
//       top:0;
//       height:439px;
//       width:2px;
//       background: linear-gradient(45deg, rgba(94, 101, 146, 0.4) 0%, #464C74 62%, rgba(48, 53, 89, 0.4) 100%);
//     }
//     .transCC-box7{
//       position: absolute;
//       top: 527px;
//       left: 0;
//       width: 100%;
//       height: 386px;
//     }
//     .transCC-box9 {
//       position: absolute;
//       right:0;
//       left: 0;
//       top: 513px;
//       height: 14px;
//       z-index: 100;
//       text-align: center;
//       cursor: pointer;
//     }

//   }
// }
#transCC-change {
  .transCC-outbox {
    // display: flex;
    position: relative;
    // width: 1920px;
    height: calc(100vh - 41.56px);
    overflow: hidden;
    .transCC-box{
      display: inline-block;
    }
    // .transCC-box1{
    //   position: absolute;
    //   top: 0;
    //   left: 0;
    //   width: 352px;
    //   height: 501px;
    // }
    // newheaderline 头部盘口
    .transCC-box2{
      position: absolute;
      top: 3px;
      left: 0;
      width: 100%;
      height: 40px;
    }
    // K线
    .transCC-box3{
      position: absolute;
      top: 49px;
      left: 0;
      width:  calc(100% - 367px);
      // height: calc(100vh - 65px - 41.56px);
      height: calc(100vh - 42px - 84px);
      background: #141517;
    }
    .transCC-new-box{
      position: absolute;
      top: 49px;
      right: 0;
      width: 361px;
      height: 583px;
      overflow: hidden;
    }
    // top3
    .transCC-box4{
      position: absolute;
      top: 49px;
      right: 0px;
      width:361px;
      // width: 361px;
      height: 194px;
    }
    // 盘口明细
    .transCC-box5{
      position: absolute;
      top: 242px;
      right: 0px;
      // width: 247px;
      width: 361px;
      height: 240px;
    }
    // tabs切换组件 收起形态
    .transCC-box6{
      position: absolute;
      right: 0;
      top: calc(100vh - 41.56px - 16px - 28px);
      width: 361px;
      height: 28px;
      z-index: 100;
    }
    // tabs切换组件 展开形态
    .tab-transCC-box6{
      position: absolute;
      right: 0;
      top: 493px;
      width: 361px;
      height: calc(100vh - 41.56px - 493px - 16px);
      z-index: 100;
    }
    // 实时成交信息
    .transCC-box8{
      position: absolute;
      right: 0;
      top: 493px;
      width: 361px;
      height: calc(100vh - 41.56px - 493px - 16px);
      z-index: 100;
      // border-left:2px solid  linear-gradient(45deg, rgba(94, 101, 146, 0.4) 0%, #464C74 62%, rgba(48, 53, 89, 0.4) 100%);
    }
    // .transCC-box8::after{
    // content:'';
    //   position: absolute;
    //   left:0;
    //   top:0;
    //   height:414px;
    //   width:2px;
    //   background: linear-gradient(45deg, rgba(94, 101, 146, 0.4) 0%, #464C74 62%, rgba(48, 53, 89, 0.4) 100%);
    // }
    .transCC-box7{
      // display: none;
      position: absolute;
      top: 100000px;
      left: 0;
      width: 0;
      height: 0;
    }
    .transCC-box9 {
      position: absolute;
      right:0;
      left: 0;
      top: calc(100vh - 41.56px - 16px);
      height: 14px;
      z-index: 100;
      text-align: center;
    }
  }
}
// ! 暂存修改 备用方案
// #transCC-change {
//   .transCC-outbox {
//     // display: flex;
//     position: relative;
//     // width: 1920px;
//     height: 953px;
//     overflow: hidden;
//     .transCC-box{
//       display: inline-block;
//     }
//     .transCC-box1{
//       position: absolute;
//       top: 0;
//       left: 0;
//       width: 352px;
//       height: 501px;
//     }
//     // newheaderline 头部盘口
//     .transCC-box2{
//       position: absolute;
//       top: 3px;
//       left: 0;
//       width: 100%;
//       height: 40px;
//     }
//     // K线
//     .transCC-box3{
//       position: absolute;
//       top: 49px;
//       left: 0;
//       width:  calc(100% - 367px);
//       height: 895px;
//     }
//     .transCC-new-box{
//       position: absolute;
//       top: 49px;
//       right: 0;
//       width: 361px;
//       height: 583px;
//     }
//     // top3
//     .transCC-box4{
//       position: absolute;
//       top: 49px;
//       right: 0px;
//       width:361px;
//       // width: 361px;
//       height: 285px;
//     }
//     // 盘口明细
//     .transCC-box5{
//       position: absolute;
//       top: 333px;
//       right: 0px;
//       // width: 247px;
//       width: 361px;
//       height: 240px;
//     }
//     // tabs切换组件 收起形态
//     .transCC-box6{
//       position: absolute;
//       right: 0;
//       top: 915px;
//       width: 361px;
//       height: 28px;
//       z-index: 100;
//     }
//     // tabs切换组件 展开形态
//     .tab-transCC-box6{
//       position: absolute;
//       right: 0;
//       top: 584px;
//       width: 361px;
//       height: 363px;
//       z-index: 100;
//     }
//     // 实时成交信息
//     .transCC-box8{
//       position: absolute;
//       right: 0;
//       top: 584px;
//       width: 361px;
//       height: 331px;
//       z-index: 100;
//       // border-left:2px solid  linear-gradient(45deg, rgba(94, 101, 146, 0.4) 0%, #464C74 62%, rgba(48, 53, 89, 0.4) 100%);
//     }
//     // .transCC-box8::after{
//     // content:'';
//     //   position: absolute;
//     //   left:0;
//     //   top:0;
//     //   height:414px;
//     //   width:2px;
//     //   background: linear-gradient(45deg, rgba(94, 101, 146, 0.4) 0%, #464C74 62%, rgba(48, 53, 89, 0.4) 100%);
//     // }
//     .transCC-box7{
//       // display: none;
//       position: absolute;
//       top: 100000px;
//       left: 0;
//       width: 0;
//       height: 0;
//     }
//     .transCC-box9 {
//       position: absolute;
//       right:0;
//       left: 0;
//       top: 944px;
//       height: 14px;
//       z-index: 100;
//       text-align: center;
//     }
//   }
// }
.transCC-box9 {
  position: absolute;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  img{
    height: 14px;
  }
}
</style>
<style>
#transcc_new_NewFooter .el-pagination button:disabled,
#transcc_new_NewFooter .el-pagination .btn-prev,
#transcc_new_NewFooter .el-pagination .btn-next,
#transcc_new_NewFooter .el-pager li,
#transcc_new_NewFooter .el-pagination__editor.el-input .el-input__inner,
#transcc_new_NewFooter .el-pagination .el-select .el-input .el-input__inner,
#transcc_new_NewFooter .el-table table tr,
#transcc_new_NewFooter .el-table th,
#transcc_new_NewFooter .el-table {
  background-color: #141517;
}
#transcc_new_NewFooter
  .el-table--striped
  .el-table__body
  tr.el-table__row--striped.current-row
  td,
#transcc_new_NewFooter .el-table__body tr.current-row > td,
#transcc_new_NewFooter .el-table__body tr.hover-row.current-row > td,
#transcc_new_NewFooter .el-table__body tr.hover-row.el-table__row--striped.current-row > td,
#transcc_new_NewFooter .el-table__body tr.hover-row.el-table__row--striped > td,
#transcc_new_NewFooter .el-table__body tr.hover-row > td {
  background-color: #141517;
}
#transcc_new_NewFooter .el-button--text {
  padding: 0;
}
#transcc_new_NewFooter .el-table__empty-block{
  min-height:180px;
}
#transcc_new_NewFooter .el-table--scrollable-x .el-table__body-wrapper{
  /* height:300px !important; */
  overflow: auto !important;
}
#transcc_new_NewFooter .el-table--enable-row-hover .el-table__body tr:hover>td{
background-color: #212e3e !important;
}
</style>
